"use strict";

var _toConsumableArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarGroup = void 0;
var react_1 = __importDefault(require("react"));
var d3_1 = require("d3");
var AtomAxis_1 = __importDefault(require("../common/AtomAxis"));
/** Default values if not passed into the component */
var defaults = {
  width: 500,
  height: 500,
  padding: 0.2,
  margin: 50,
  legend: false,
  axisColor: 'black'
};
var BarGroup = function BarGroup(_ref) {
  var d = _ref.d,
    x = _ref.x,
    y = _ref.y,
    height = _ref.height,
    width = _ref.width,
    textAnchor = _ref.textAnchor,
    textColor = _ref.textColor;
  var flipped = d.value < 0;
  return react_1.default.createElement("g", {
    key: d.label,
    transform: "translate(".concat(x, ", ").concat(y, ")")
  }, react_1.default.createElement("rect", {
    key: d.label,
    className: d.classname,
    width: width,
    height: height - y,
    fill: d.color || '#C4C4C4'
  }), react_1.default.createElement("text", {
    className: 'bar-label',
    textAnchor: textAnchor || 'middle',
    x: !textAnchor ? width / 2 : textAnchor === 'end' ? width : 0,
    y: flipped ? height - y + 5 : -5,
    dominantBaseline: flipped ? 'hanging' : 'auto',
    fill: textColor || '#C4C4C4'
  }, d.format ? d.format(d.value) : d.value));
};
exports.BarGroup = BarGroup;
/**
 * The AtomBarChart is a standard bar chart with customizable inputs.
 * @param data An array of objects, with objects of type datum: { label: string; value: number; color: string; group?: string; format?: fn, classname?: string }.
 * @param width The width of the container for scale measurements
 * @param height The height of the container for scale measurements
 * @param padding Padding to include between the bars (from 0 to 1)
 * @param margin Margin to consider with the width and height
 * @param axisColor A color to pass to the axis component
 * @returns bar chart react component
 */
var AtomBarChart = function AtomBarChart(_ref2) {
  var data = _ref2.data,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? defaults.width : _ref2$width,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? defaults.height : _ref2$height,
    _ref2$padding = _ref2.padding,
    padding = _ref2$padding === void 0 ? defaults.padding : _ref2$padding,
    _ref2$margin = _ref2.margin,
    margin = _ref2$margin === void 0 ? defaults.margin : _ref2$margin,
    _ref2$axisColor = _ref2.axisColor,
    axisColor = _ref2$axisColor === void 0 ? defaults.axisColor : _ref2$axisColor;
  var groupedData = (0, d3_1.groups)(data, function (d) {
    return d.group || '';
  });
  var grouped = groupedData.length > 1; // grouped bar chart or regular bar chart?
  var groupings = groupedData.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return key;
  });
  var labels = Array.from(new Set(data.map(function (d) {
    return d.label;
  })));
  var x0 = (0, d3_1.scaleBand)().domain(groupings).range([margin, width - margin]).padding(padding);
  var x1 = (0, d3_1.scaleBand)().domain(labels).range([0, x0.bandwidth()]).padding(grouped ? 0.1 : padding);
  var y = (0, d3_1.scaleLinear)().domain([0, Math.max.apply(Math, _toConsumableArray(data.map(function (d) {
    return d.value;
  })))]).range([height - margin, margin]).nice();
  return react_1.default.createElement("svg", {
    width: '100%',
    height: '100%',
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, react_1.default.createElement(AtomAxis_1.default, {
    ticks: y.ticks(),
    scale: y,
    orientation: 'right',
    offset: [width - margin, 0],
    tickLength: width - margin - margin,
    color: axisColor
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: groupings,
    scale: x0,
    orientation: 'bottom',
    offset: [x0.bandwidth() / 2, height - margin],
    color: axisColor
  }), groupedData.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      group = _ref6[0],
      data = _ref6[1];
    return react_1.default.createElement("g", {
      key: group,
      transform: "translate(".concat(x0(group) || 0, ", 0)")
    }, data.map(function (d) {
      return react_1.default.createElement(exports.BarGroup, {
        key: "".concat(group, "_").concat(d.label),
        d: d,
        x: x1(d.label) || 0,
        y: y(d.value),
        height: height - margin,
        width: x1.bandwidth(),
        textColor: axisColor
      });
    }));
  }));
};
exports.default = react_1.default.memo(AtomBarChart);